<template>
  <div v-loading="loading">
    <div class="header">
      <el-select v-model="info_type" @change="getStateBudget">
        <el-option v-for="{type, title} in infoTypes" :key="type" :value="type"
                   :label="title"/>
      </el-select>
      <el-button type="primary" @click="$router.push({name: 'SateBudgetAdd'})">Davlat budjeti turi qo'shish</el-button>
    </div>
    <el-table :data="tableData" border height="calc(100vh - 250px)">
      <el-table-column type="index" label="T/r" />
      <el-table-column prop="budget_year" label="Budjet yili"/>
      <el-table-column prop="added_at" label="Qo'shilgan sanasi">
        <template #default="scope">
          {{$moment(scope.row.added_at).format("DD.MM.YYYY")}}
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template #default="scope">
          <el-button size="small" type="primary" @click="$router.push({name: 'StateBudgetRows', params:{stateBudgetId: scope.row.id}})">Davlat budjeti ma'lumotlari</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";

export default {
  name: "StateBudgetList",
  data() {
    return {
      loading: false,
      tableData: [],
      info_type: 'INCOME',
      infoTypes: [{type:'INCOME', title: 'Daromadlar'},{type:'OUTCOME', title: 'Xarajatlar'}]
    }
  },
  methods: {

    getStateBudget() {
      this.loading = true
      this.$http.get(`api/v1/state-budget?info_type=${this.info_type}`).then(({data}) => {
        this.tableData = data
      }).catch(({response}) => {
        ElNotification.error({
          message: response.data.message || "Ma'lmumot yuklasda xatolik sodir bo'ldi!"
        })
      }).finally(() => {
        this.loading = false
      })
    },

  },
  mounted() {
    this.getStateBudget();
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  gap: 10px;
}
</style>